<script>
import { mapActions } from 'vuex';
import { sortBy } from 'lodash';
import { isEmpty, appendIndexForEachElement } from 'src/utils';
import { requiredRule } from 'src/utils/helper';

async function getOpenCasesByCustomerId(vm) {
  return await vm.getOpenCases(vm.value.customerId);
}

export default {
  props: ['value'],
  data() {
    return {
      header: this.value.header,
      existingCaseForm: false,
      itemIndex: null,
      selectedCaseId: null,
      selectedCaseName: '',
      cases: [],
      loading: true,
      openedForTransferCases: false,
      rules: {
        required: requiredRule,
      },
    };
  },
  async mounted() {
    this.$watch('value.customerId', () => {
      this.cases = [];
    });
    const openedCases = await getOpenCasesByCustomerId(this);
    this.loading = false;
    if (!isEmpty(openedCases)) {
      const currentActivityCase = `${this.value.caseId}`;
      const cases = openedCases.filter((kase) => kase.id !== currentActivityCase);
      if (cases.length) {
        this.openedForTransferCases = true;
      }
      this.cases = appendIndexForEachElement([
        { header: ' ' },
        ...sortBy(cases, (item) => parseInt(item.id, 10)),
      ]);
    }
  },
  methods: {
    ...mapActions('operator', ['getOpenCases']),
    ...mapActions('activities', ['updateActivityCase']),
    closeExistingCaseForm() {
      this.existingCaseForm = false;
      this.$emit('close');
    },
    select(intent) {
      this.$emit('select', this.cases[intent]);
      this.selectedCaseId = this.cases[intent].id;
      this.selectedCaseName = this.cases[intent].name;
    },
    async locChangeCase() {
      this.$refs.existingCaseForm.withErrorHandling(async () => {
        await this.updateActivityCase({
          id: this.value.activityId,
          caseId: this.selectedCaseId,
        });
        this.close();
      });
    },
    close() {
      this.$parent.close([null]);
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  vc-form(ref="existingCaseForm", @submit="locChangeCase", v-if="openedForTransferCases")
    header(:class="$style.header")
      div(:class="$style.headerTitle", data-test="EXISTING_CASE") {{ header }}
    div(:class="$style.content")
      v-select#open-cases(:label="$t('T_SELECT_CASE')",
        v-model="itemIndex",
        @input="select",
        :items="cases",
        item-text="name",
        item-value="index",
        :menu-props="{ zIndex: 10009 }"
        :class="$style.required",
        :rules="[rules.required]",
        required,
        @select="select")
        template(slot="item", slot-scope="data")
          | {{ data.item.gg }}
          div(v-if="data.item.index === 1", :class="$style.headerSelect")
            div(:class="$style.headerSelectId") {{ $t('T_ID') }}
            div(:class="$style.headerSelectName") {{ $t('T_LAST_ACTIVITY_REQUEST_TYPE') }}
            div(:class="$style.headerSelectChannel") {{ $t('T_LAST_ACTIVITY_CHANNEL') }}
            div(:class="$style.headerSelectTime") {{ $t('T_LAST_MESSAGE_TIME') }}
          div(:class="$style.itemSelect")
            div(:class="$style.headerSelectId") ID: {{ data.item.id }}
            div(:class="$style.headerSelectName") {{ data.item.lastActivity.requestType.name }}
            div(:class="$style.headerSelectChannel") {{ data.item.lastActivity.channelName }}
            div(:class="$style.headerSelectTime"
              v-if="data.item.lastNonSystemMessage") {{ data.item.lastNonSystemMessage.insertedAt | formatDateTime }}
    div(:class="$style.action", date-test="REPLY_BUTTON")
      ui-button(colored="green", @submit="locChangeCase",
        @keyup.enter.native="locChangeCase",
        :disabled="!itemIndex", data-test="SEND_CASE") {{ $t('T_SEND') }}
      ui-button(colored="red", :class="$style.cancel", @click.native="close",
        @keyup.enter.native="close", data-test="CANCEL_SEND_CASE") {{ $t('T_CANCEL') }}
  div(v-if="!openedForTransferCases && !loading")
    header(:class="$style.header")
      div(:class="$style.headerTitle") {{ $t('T_NOT_OPEN_CASES') }}
    div(:class="$style.action", date-test="REPLY_BUTTON")
      ui-button(@click.native="close", @keyup.enter.native="close") {{ $t('T_CANCEL') }}
  ui-progress(:class="$style.loading", v-if="loading")
</template>

<style lang="sass" module>
.root
  display: block
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.content
  display: flex
  flex-direction: column
  padding: 24px
  min-width: 800px
.action
  display: flex
  padding: 24px
  justify-content: space-around
.cancel
  margin-left: 16px
.loading
  position: absolute
  left: 0
  right: 0
  bottom: 0
.headerSelect
  position: absolute
  top: -50px
  pointer-events: none
  color: rgba(0, 0, 0, 0.54)
  height: 48px
  display: flex
  align-items: flex-start
  font-size: 14px
  font-weight: 500
.itemSelect
  display: flex
  align-items: flex-start
  font-size: 14px
  font-weight: 400
  padding: 3px 0
.firstItem
  margin-top: 30px
.headerSelectId
  width: 70px
.headerSelectName
  width: 220px
  padding: 0 6px
.headerSelectChannel
  width: 220px
  padding: 0 6px
.headerSelectTime
  width: 210px
  padding: 0 6px
.required label::after
  content: "*"
  color: $color_red
</style>
